import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ContinuityOfferService } from '../../services/continuity-offer.service'


// Unit Of Measure to Display based on OMS Offer Data: 
// ITEM = "Purchased" 
// WEIGHT_VOLUME - "Quantity" 
// DOLLARS = Spent with "$" as prefix to values for progress and goal ex. Purchased - $10/$20 
// QUANTITY_PRICE ="Purchased" 
// QUANTITY - "Quantity" 
// POUND = "Purchased" & "Lbs" after values 
// AMOUNT = "Purchased"
const units: any = [
  {
    unit: 'ITEM',
    usePrefix: 'Purchased',
    valuePrefix: '',
    valuePostFix: ''
  },
  {
    unit: 'ITEMS',
    usePrefix: 'Purchased',
    valuePrefix: '',
    valuePostFix: ''
  },
  {
    unit: 'AMOUNT',
    usePrefix: 'Purchased',
    valuePrefix: '',
    valuePostFix: ''
  },
  {
    unit: 'DOLLARS',
    usePrefix: 'Purchased',
    valuePrefix: '$',
    valuePostFix: ''
  },
  {
    unit: 'QUANTITY_PRICE',
    usePrefix: 'Purchased',
    valuePrefix: '',
    valuePostFix: ''
  },
  {
    unit: 'POUND',
    usePrefix: 'Purchased',
    valuePostFix: 'Lbs',
    valuePrefix: '',
  },
  {
    unit: 'PER POUND',
    usePrefix: 'Purchased',
    valuePostFix: 'Lbs',
    valuePrefix: '',
  },
  {
    unit: 'WEIGHT_VOLUME',
    usePrefix: 'Quantity',
    valuePrefix: '',
    valuePostFix: ''
  },
  {
    unit: 'WEIGHT/VOLUME',
    usePrefix: 'Quantity',
    valuePrefix: '',
    valuePostFix: ''
  },
  {
    unit: 'QUANTITY',
    usePrefix: 'Quantity',
    valuePrefix: '',
    valuePostFix: ''
  }
];

@Component({
  selector: 'app-continuity-offer',
  templateUrl: './continuity-offer.component.html',
  styleUrls: ['./continuity-offer.component.scss']
})
export class ContinuityOfferComponent implements OnInit {

  public windowObj: any = window;
  public id: any = 'REPLACEME!'

  public startChallengeLabel: string;
  public challengeCompletedLabel: string;
  /* TO BE REMOVED IN BONUS PATH 2.0 */
  @Input() continuity: any = {};
  @Input() programType: string = '';
  @Input() challengeCompletedLabelColor: string = '#757575';
  @Input() fontSize: string = 'inherit';
  /* ******* */
  @Output() startChallengeEvent = new EventEmitter();
  @Input() isClipped: boolean = false; // TO BE REMOVED IN BONUS PATH 2.0
  @Input() showLoadingCoupon: boolean = false;
  // public challengeCompletedLabelColor: string = '#0C7D50';
  @Input() couponData: any;
  @Input() isOfferDetailsPage: boolean = false;
  @Input() behavioralOfferAttrs: any;
  @Input() isCouponCarosel: any;
  isBehaviorCoupon: boolean = false;
  isContinuityCoupon: boolean = false;
  isCouponClipped: boolean = false;
  isBonusPathCompleted: boolean = false;
  isBonusPathV2Active: boolean = true;

  constructor(public continuityOfferService: ContinuityOfferService) {
    // this.isBonusPathV2Active = this.continuityOfferService.enableBonusPathV2Flag;
    this.behavioralOfferAttrs = {...this.continuityOfferService.behavioralOfferAttrs};
    this.startChallengeLabel = this.windowObj['SWY'].CONFIGSERVICE.nimbusConfig.couponActionTypes['SCC'];
    this.challengeCompletedLabel = this.windowObj['SWY'].CONFIGSERVICE.nimbusConfig.couponActionTypes['CC'];
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.isOfferDetailsPage && this.couponData.deleted) {
      this.couponData.status = 'U'
    }
    if (this.isBonusPathV2Active) {
      this.checkOfferStatus();
    }
  }

  startChallenge() {
    this.showLoadingCoupon = true;
    this.startChallengeEvent.emit();
  }

  navigateTo(offerChallegeLink: any) {
    this.showLoadingCoupon = true;
    this.windowObj.location.pathname = offerChallegeLink;
  }

  offerDataDisplay(data: any) {
    let vals: any = {};
    if (data?.units) {
      const findIndexFromUnits = units.findIndex(
        (u: any) => u.unit.toLowerCase() === data.units.toLowerCase()
      );
  
      if (findIndexFromUnits >= 0) {
        const _unit = units[findIndexFromUnits];
        vals = {
          prefix: _unit.usePrefix,
          progressVal: _unit.valuePrefix
            ? `${_unit.valuePrefix}${data.progressValue}`
            : _unit.valuePostFix
            ? `${data.progressValue}${_unit.valuePostFix}`
            : data.progressValue,
          targetVal: _unit.valuePrefix
            ? `${_unit.valuePrefix}${data.targetValue}`
            : _unit.valuePostFix
            ? `${data.targetValue}${_unit.valuePostFix}`
            : data.targetValue,
        };
      }
    } else {
      vals = {
        prefix: 'Transactions',
        progressVal: data.progressValue,
        targetVal: data.targetValue
      }
    }

    return vals;
  }

  checkOfferStatus() {
    if ( (this.couponData.status && this.couponData.status === 'C') || (!this.couponData.status && !this.couponData.deleted)) {
      this.isCouponClipped = true;
      if (this.couponData.continuity) {
        this.isBonusPathCompleted = this.couponData.continuity.progressValue === this.couponData.continuity.targetValue;
        this.isContinuityCoupon = true;
        this.isBehaviorCoupon = false;
      } else if (this.couponData.qualificationBehavior && this.couponData.qualificationBehavior !== '') {
        this.isBonusPathCompleted = this.couponData.bonusPathStatus !== '' && this.couponData.bonusPathStatus.toLowerCase() !== 'inprogress';
        this.isContinuityCoupon = false;
        this.isBehaviorCoupon = true;
      } else if (this.continuityOfferService.isFreshpassContinuityCoupon(this.couponData)) {
        this.isBonusPathCompleted = true;
        this.isContinuityCoupon = true;
        this.isBehaviorCoupon = false;
      }
    } else if (this.couponData.status === 'U' && !this.couponData.deleted) {
      this.isCouponClipped = false;
    }
  }

  convertString(value: any){
    return parseFloat(value)
  }

}

